import { Fragment,useState, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { useTheme } from "../../utils/themeUtils";
import { SuccessIcon, FailIcon, InformationIcon, CancelIcon } from "../../utils/iconFactory";
import { classNames } from '../../utils/utils';

export type PopupIconOptionsType = "success" | "fail" | "info" | null
export type PopupMessageType = {id: string, text: string, iconOption: PopupIconOptionsType}

interface PopupProps {
  popupMessage: PopupMessageType,
  closePopup: () => void
}

export const PopupModal = ({ popupMessage, closePopup }: PopupProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [localText, setLocalText] = useState("")
  const [localIcon, setLocalIcon] = useState("info")
  const { themeString } = useTheme()

  useEffect(() => {
    if (popupMessage.id !== "") {
      setIsVisible(false);
      setTimeout(() => {
        setIsVisible(true);
        setLocalText(popupMessage.text);
        if (popupMessage.iconOption) setLocalIcon(popupMessage.iconOption)
      }, 300);
    } else {
      setIsVisible(false);
    }
  }, [popupMessage.id]);

  let CurrIcon: JSX.Element | null = null;
  switch (localIcon) {
    case "success":
      CurrIcon = <SuccessIcon className="h-6 w-6 mr-3 text-primaryActionAltHover fill-current" />;
      break;
    case "fail":
      CurrIcon = <FailIcon className="h-6 w-6 mr-3 text-tertiaryRed fill-current" />;
      break;
    case "info":
      CurrIcon = <InformationIcon className="h-6 w-6 mr-3 text-gray0 fill-current" />;
      break;
    default:
      CurrIcon = <InformationIcon className="h-6 w-6 mr-3 text-gray0 fill-current" />;
      break;
  }

  return (
    <Transition.Root show={isVisible} as={Fragment}>
      <div className={classNames("relative z-50", themeString)}>
        <div className='fixed inset-0 pointer-events-none overflow-hidden justify-center top-0 flex h-fit'>
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in-out duration-500"
            enterFrom='-translate-y-full'
            enterTo='translate-y-0'
            leave='transform transition ease-in-out duration-500'
            leaveFrom='translate-y-0'
            leaveTo='-translate-y-full'
          >
            <div className="pointer-events-auto relative">
              <div className="relative min-w-[499px] bg-textMain text-backgroundWhite rounded-b-[12px] p-4 flex justify-between">
                <div id='left' className='flex'>
                  {CurrIcon}
                  <p className='text-backgroundWhite text-style-body2'>{localText}</p>
                </div>
                <button onClick={closePopup}>
                  <CancelIcon className="h-6 w-6 text-gray10 fill-current" />                     
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </div>
    </Transition.Root>
  );
};
